<template>
  <div>
    <div class="block" v-for="field in fields" :key="field.slug">
      <div v-if="field.type === 'checkbox'">
        <SubHeaderBlock>{{ field.label }}</SubHeaderBlock>
        <v-checkbox
          class="mt-0"
          v-model="form[field.slug]"
          v-for="answer in field.answers"
          :key="answer"
          :label="answer"
          :value="answer"
          @change="change"
        ></v-checkbox>
      </div>

      <div v-if="field.type === 'eva'">
        <SubHeaderBlock>{{ field.label }}</SubHeaderBlock>
        <v-slider
          class="mt-5 mb-2"
          v-model="form[field.slug]"
          step="1"
          thumb-label="always"
          ticks="always"
          tick-size="2"
          :tick-labels="range(field.range[0], field.range[1])"
          :min="field.range[0]"
          :max="field.range[1]"
          @change="change"
        ></v-slider>
        <div
          class="text-center mb-2 grey--text"
          style="font-size: 22px; font-weight: 700"
        >
          <span class="primary--text">{{ form[field.slug] }}</span> /
          {{ field.range[1] }}
        </div>
        <div
          class="text-center grey--text mb-2"
          style="font-size: 22px; font-weight: 700"
          v-if="field.range_labels"
        >
          "{{ field.range_labels[form[field.slug] - 1 || 0] }}"
        </div>
        <div class="mb-5" style="display: flex; justify-content: center">
          <v-btn
            class="primary"
            round
            large
            style="font-weight: 700; font-size: 28px"
            @click="
              form[field.slug]--;
              change();
            "
            >-
          </v-btn>
          <v-btn
            class="primary"
            round
            large
            style="font-weight: 700; font-size: 28px"
            @click="
              form[field.slug]++;
              change();
            "
            >+
          </v-btn>
        </div>
      </div>

      <div v-if="field.type === 'radio'">
        <SubHeaderBlock class="mb-0">{{ field.label }}</SubHeaderBlock>
        <v-radio-group class="mt-0" v-model="form[field.slug]">
          <v-radio
            class="mt-3"
            v-for="answer in field.answers"
            :key="answer"
            :value="answer"
            @change="change"
          >
            <div slot="label">{{ answer }}</div>
          </v-radio>
        </v-radio-group>
      </div>

      <div v-if="field.type === 'textarea'">
        <SubHeaderBlock>{{ field.label }}</SubHeaderBlock>
        <v-textarea
          v-model="form[field.slug]"
          solo
          :placeholder="field.placeholder"
          @change="change"
        ></v-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import _range from "lodash/range";
import SubHeaderBlock from "./SubHeaderBlock";
import Vue from "vue";

export default {
  components: { SubHeaderBlock },
  data() {
    return {
      form: {},
    };
  },

  methods: {
    change() {
      this.$emit("change", this.form);
    },

    range() {
      _range(arguments);
    },
  },

  mounted() {
    this.fields.forEach((field) => {
      Vue.set(this.form, field.slug, field.type === "checkbox" ? [] : null);
    });
  },

  props: {
    fields: {
      required: true,
      type: Array,
    },
  },
};
</script>
